<template>
  <!-- <footer class="mt-5" style="background: #dddddddd; height: 70px">
    <div class="container">
      <div class="row text-center" style="padding: 10px">
        <div class="col-12 mt-3">
          &copy; Copyright 2021. Made with &#128150; by
          <strong>Aldi Tegar Prakoso</strong>
        </div>
      </div>
    </div>
  </footer> -->
  <footer id="footer">
    <small>&copy; 2021. Made with &#10084;&#65039; by Aldi Tegar Prakoso</small>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style>
</style>